var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaugeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 77C60.4345 77 77 60.4345 77 40C77 19.5655 60.4345 3 40 3C19.5655 3 3 19.5655 3 40C3 60.4345 19.5655 77 40 77ZM40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80Z",
    fill: "#528FF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 40C70.5 40.8284 69.8284 41.5 69 41.5C68.1716 41.5 67.5 40.8284 67.5 40C67.5 24.8122 55.1878 12.5 40 12.5C24.8122 12.5 12.5 24.8122 12.5 40C12.5 40.8284 11.8284 41.5 11 41.5C10.1716 41.5 9.5 40.8284 9.5 40C9.5 23.1553 23.1553 9.5 40 9.5C56.8447 9.5 70.5 23.1553 70.5 40Z",
    fill: "#FF6060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 46.5C37.1863 46.5 34.5 43.8137 34.5 40.5C34.5 37.1863 37.1863 34.5 40.5 34.5C43.8137 34.5 46.5 37.1863 46.5 40.5C46.5 43.8137 43.8137 46.5 40.5 46.5ZM40.5 43.5C42.1569 43.5 43.5 42.1569 43.5 40.5C43.5 38.8431 42.1569 37.5 40.5 37.5C38.8431 37.5 37.5 38.8431 37.5 40.5C37.5 42.1569 38.8431 43.5 40.5 43.5Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 20.5C42 19.6716 41.3284 19 40.5 19C39.6716 19 39 19.6716 39 20.5V34.5C39 35.3284 39.6716 36 40.5 36C41.3284 36 42 35.3284 42 34.5V20.5Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4346 44.9209C67.6403 44.1184 68.4576 43.6346 69.2601 43.8403C70.0626 44.046 70.5463 44.8633 70.3406 45.6658C69.4152 49.276 67.9073 52.5723 65.8195 55.5461C63.7259 58.528 62.2201 60.3218 61.1278 61.0496C60.4385 61.509 59.5072 61.3226 59.0478 60.6332C58.5884 59.9438 58.7749 59.0125 59.4643 58.5531C60.1336 58.1071 61.4916 56.4894 63.3642 53.8223C65.2425 51.147 66.5985 48.1827 67.4346 44.9209Z",
    fill: "#7BC658"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 65C57.3284 65 58 64.3284 58 63.5C58 62.6716 57.3284 62 56.5 62C55.6716 62 55 62.6716 55 63.5C55 64.3284 55.6716 65 56.5 65Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeIcon);
export default __webpack_public_path__ + "static/media/gaugeIcon.aaac7173978e1bfea83e88c8ac1b6658.svg";
export { ForwardRef as ReactComponent };